var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnectIgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.925 9.613c3.027 0 3.031 4.58 0 4.58-3.026 0-3.03-4.58 0-4.58z",
    fill: "url(#connect-ig-icon_svg__paint0_linear_7070_120627)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.925 9.613c3.027 0 3.031 4.58 0 4.58-3.026 0-3.03-4.58 0-4.58z",
    fill: "#A5BBD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.414 6.265c-.346.003-.714.006-1.104.007V6.27c-4.58.005-5.014.092-5.014 5.63 0 5.475.158 5.631 5.63 5.631.276 0 .548.003.813.006 2.618.029 4.643.051 4.776-2.86.385-8.464-.24-8.458-5.1-8.412zm2.354 1.971a.824.824 0 111.648 0 .824.824 0 01-1.648 0zm-6.37 3.667a3.527 3.527 0 117.055 0 3.527 3.527 0 01-7.054 0z",
    fill: "url(#connect-ig-icon_svg__paint1_linear_7070_120627)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.414 6.265c-.346.003-.714.006-1.104.007V6.27c-4.58.005-5.014.092-5.014 5.63 0 5.475.158 5.631 5.63 5.631.276 0 .548.003.813.006 2.618.029 4.643.051 4.776-2.86.385-8.464-.24-8.458-5.1-8.412zm2.354 1.971a.824.824 0 111.648 0 .824.824 0 01-1.648 0zm-6.37 3.667a3.527 3.527 0 117.055 0 3.527 3.527 0 01-7.054 0z",
    fill: "#A5BBD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.611 9.786c-.036-3.301-.05-4.644 1.177-5.92 1.289-1.336 2.696-1.324 7.625-1.283 1.02.009 2.192.019 3.545.018 2.182.004 2.306.022 2.72.082l.023.003c1.89.272 3.325 1.616 3.508 3.946.025.312.025 10.226 0 10.532-.171 2.188-1.43 3.443-2.977 3.842-1.16.3-11.44.3-12.6.002-3.195-.826-3.119-3.957-3.034-7.405.014-.563.028-1.134.028-1.704 0-.784-.008-1.484-.015-2.113zm8.635-4.755a94.302 94.302 0 001.462 0c2.194-.015 3.749-.026 4.93 1.156 1.177 1.176 1.168 2.705 1.156 4.97-.001.24-.003.49-.003.746l.002.687c.006 1.656.01 2.848-.362 3.812-.943 2.419-3.339 2.397-5.799 2.374a76.104 76.104 0 00-1.384 0c-2.543.018-4.894.035-5.83-2.374-.373-.958-.368-2.382-.362-3.932l.001-.567c0-.234 0-.46-.002-.678-.006-1.657-.01-2.865.363-3.821.938-2.409 3.272-2.392 5.828-2.373z",
    fill: "url(#connect-ig-icon_svg__paint2_linear_7070_120627)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.611 9.786c-.036-3.301-.05-4.644 1.177-5.92 1.289-1.336 2.696-1.324 7.625-1.283 1.02.009 2.192.019 3.545.018 2.182.004 2.306.022 2.72.082l.023.003c1.89.272 3.325 1.616 3.508 3.946.025.312.025 10.226 0 10.532-.171 2.188-1.43 3.443-2.977 3.842-1.16.3-11.44.3-12.6.002-3.195-.826-3.119-3.957-3.034-7.405.014-.563.028-1.134.028-1.704 0-.784-.008-1.484-.015-2.113zm8.635-4.755a94.302 94.302 0 001.462 0c2.194-.015 3.749-.026 4.93 1.156 1.177 1.176 1.168 2.705 1.156 4.97-.001.24-.003.49-.003.746l.002.687c.006 1.656.01 2.848-.362 3.812-.943 2.419-3.339 2.397-5.799 2.374a76.104 76.104 0 00-1.384 0c-2.543.018-4.894.035-5.83-2.374-.373-.958-.368-2.382-.362-3.932l.001-.567c0-.234 0-.46-.002-.678-.006-1.657-.01-2.865.363-3.821.938-2.409 3.272-2.392 5.828-2.373z",
    fill: "#A5BBD4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect-ig-icon_svg__paint0_linear_7070_120627",
    x1: 21.6,
    y1: 2.743,
    x2: 2.743,
    y2: 21.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect-ig-icon_svg__paint1_linear_7070_120627",
    x1: 21.6,
    y1: 2.743,
    x2: 2.743,
    y2: 21.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect-ig-icon_svg__paint2_linear_7070_120627",
    x1: 21.6,
    y1: 2.743,
    x2: 2.743,
    y2: 21.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })))));
}

export default __webpack_public_path__ + "./fonts/connect-ig-icon.8ceb22e9028ebffcd4d9bea9bf39bb53.svg";
export { SvgConnectIgIcon as ReactComponent };